module.exports = __webpack_public_path__ + "static/img/abvl-D66gZMS2.f1ff446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/abvl-D66gZMS2.png
// module id = UHx5
// module chunks = 16